import { Injectable, WritableSignal, inject, signal } from "@angular/core";
import { ApiService } from "./api.service";
import { SignalsStoreService } from "./signals-store.service";
import { RequestHandlerParams } from "./types/api-service.types";
import { filter, tap } from "rxjs";
import { ApiResponse } from "./common/types";
import { SidebarService } from "./sidebar/sidebar.service";

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  private apiService = inject(ApiService);
  private signalStoreService = inject(SignalsStoreService);
  private sidebarService = inject(SidebarService);

  menu: WritableSignal<any[]> = signal([]);

  private endpoints = {
    base: '/menu',
    categories: '/categories',
    territories: '/territories'
  };

  fetchMenuCategories() {
    this.menu.set([]);

    const params: RequestHandlerParams = {
      method: 'GET',
      endpoint: `${this.endpoints.base}/${this.endpoints.categories}`,
      apiV3: true
    };

    return this.apiService.handleRequest<ApiResponse<{ categories: any[] }>>(params).pipe(
      filter((response: ApiResponse<{ categories: any[] }>) => !!response.data?.categories?.length),
      tap((response: ApiResponse<{ categories: any[] }>) => {
        this.setUpMenuData(response.data.categories);
        this.sidebarService.setUpSidebarData({ sidebarData: response.data, isFirstTime: true });
      }),
    );
  }

  setUpMenuData(menu: any[]) {
    this.signalStoreService.menuSignal.set(menu);
    this.signalStoreService.menu = [...menu];
    // this.#setCategoryInViewPort(menu[0]);
  }

  #setCategoryInViewPort(category: any) {
    this.signalStoreService.categoryInViewPort.set({
      categoryId: category.id,
      subCategoryId: category.subCategories[0]?.id,
    });
  }

}
